<template>
  <div 
    class="slot">
    <div
      v-if="slotProp.previous_planning_event"
      class="slot-previous-event"
      :class="{ 'visible': extended }">
      <div style="margin: 10px;">
        <p>
          <strong>Rendez-vous précédent</strong>
        </p>

        <p v-if="slotProp.previous_planning_event.intervention">
          <button
            class="btn-link"
            @click="openInterventionInNewTab(slotProp.previous_planning_event.intervention.id)">
            Intervention pour {{ $filters.fullname(slotProp.previous_planning_event.intervention.contact) }} <i class="bi bi-box-arrow-up-right" />
          </button>
        </p>

        <p v-else-if="slotProp.previous_planning_event.event_type == 'personnal_event'">
          Evènement perso
        </p>

        <p v-else-if="slotProp.previous_planning_event.event_type == 'leave'">
          Congé
        </p>

        <p>{{ $filters.capitalize(previousPlanningEventStartAndEndDate) }}</p>
        
        <p style="margin-bottom: 0;">
          Lieu:
          <span
            v-if="slotProp.previous_planning_event.location"
            style="margin-left: 5px;">
            {{ slotProp.previous_planning_event.location }}
          </span>

          <i 
            v-else
            style="margin-left: 5px;">Inconnu</i>

          <span
            v-if="slotProp.previous_planning_event.latitude && slotProp.previous_planning_event.longitude"
            style="margin-left: 5px;">
            ({{ slotProp.previous_planning_event.latitude }}, {{ slotProp.previous_planning_event.longitude }})
          </span>

          <a
            v-if="slotProp.previous_planning_event.latitude && slotProp.previous_planning_event.longitude"
            style="margin-left: 5px;"
            :href="`https://www.google.com/maps/search/?api=1&query=${ slotProp.previous_planning_event.latitude },${ slotProp.previous_planning_event.longitude }`"
            target="_blank"
            class="btn-link">
            <i class="bi bi-geo-alt" />
          </a>
        </p>
      </div>
    </div>

    <div class="slot-body">
      <div>
        <div style="cursor: pointer;" @click="toggle">
          <p v-if="slotProp.duration">
            <strong>{{ $filters.secondsToHumanDuration(slotProp.duration) }} disponibles</strong>
          </p>

          <p>
            Le {{ $filters.dateStringToHumanizedDate(slotProp.previous_planning_event ? slotProp.previous_planning_event.end_date : slotProp.next_planning_event.start_date) }}
            <span v-if="slotProp.previous_planning_event && slotProp.next_planning_event"> entre </span>
            <span v-else-if="slotProp.previous_planning_event"> a partir de </span>
            <span v-else-if="slotProp.next_planning_event"> jusqu'à </span>
            <span v-if="slotProp.previous_planning_event">{{ slotProp.previous_planning_event.end_time }}</span>
            <span v-if="slotProp.previous_planning_event && slotProp.next_planning_event"> et </span>
            <span v-if="slotProp.next_planning_event">{{ slotProp.next_planning_event.start_time }}</span>
          </p>

          <p>
            Pour <strong>{{ $filters.fullname(slotProp.user) }}</strong>
          </p>
          
          <p>
            <span style="margin-right: 5px;">Distance additionnel :</span>

            <strong
              v-if="slotProp.additional_distance != null"
              style="margin-right: 5px;">
              <span v-if="!isNaN(slotProp.additional_distance)">{{ Math.round(slotProp.additional_distance) }}km à vol d'oiseau</span>
              <span v-else>{{ slotProp.additional_distance }}</span>
            </strong>

            <i
              v-else
              style="margin-right: 5px;">Inconnue</i>

            <a
              v-if="slotProp.previous_planning_event && slotProp.next_planning_event"
              :href="`https://www.google.com/maps/dir/${ slotProp.previous_planning_event.location }/${interventionAddress}/${ slotProp.next_planning_event.location }`"
              target="_blank"
              class="btn-link">
              <i class="bi bi-map" />
              Voir le trajet sur Google Maps
            </a>
          </p>
        </div>

        <div class="horizontal-spaced-container align-right">
          <button
            class="btn-link"
            @click="$refs.detailsModal.show()">
            Voir le détail du calcul
          </button>

          <button
            class="btn-secondary"
            @click="$refs.selectSlotModal.show(slotProp, intervention)">
            Sélectionner
          </button>          
        </div>

        <Modal ref="detailsModal" width="medium">
          <div
            v-if="slotProp.previous_planning_event">
            <p>Heure de fin du précédent rendez-vous : {{ slotProp.previous_planning_event.end_time }}</p>
            <p>Temps de trajet estimé depuis le précédent rendez-vous : {{ durationTripFromPreviousPlanningEvent != null ? $filters.secondsToHumanDuration(durationTripFromPreviousPlanningEvent) : "Inconnu" }}</p>
            <p>Heure conseillée pour programmer l'intervention : {{ slotProp.previous_planning_event.end_time }} + {{ durationTripFromPreviousPlanningEvent != null ? $filters.secondsToHumanDuration(durationTripFromPreviousPlanningEvent) : "Inconnu" }} = {{ advisedStartTime }}</p>
            <p>Durée estimée de l'intervention : {{ interventionDuration }}</p>
            <p>Heure conseillée de fin d'intervention : {{ advisedStartTime }} + {{ interventionDuration }} = {{ advisedEndTime }}</p>
            <p v-if="slotProp.next_planning_event">
              Heure de début du prochain rendez-vous : {{ slotProp.next_planning_event.start_time }}
            </p>
            <p v-if="slotProp.next_planning_event">
              Temps de trajet estimé jusqu'au prochain rendez-vous : {{ durationTripToNextPlanningEvent != null ? $filters.secondsToHumanDuration(durationTripToNextPlanningEvent) : "Inconnu" }}
            </p>
            <p v-if="slotProp.next_planning_event">
              Heure la plus tardive pour quitter l'intervention et arriver au rendez-vous suivant à l'heure : TODO
            </p>
            <p v-if="slotProp.next_planning_event">
              Temps libre entre l'intervention et le rendez-vous suivant : TODO
            </p>
          </div>

          <div
            v-else-if="slotProp.next_planning_event">
            <p>Heure de début du rendez-vous suivant : {{ slotProp.next_planning_event.start_time }}</p>
            <p>Temps de trajet estimé jusqu'au endez-vous suivant : {{ durationTripToNextPlanningEvent != null ? $filters.secondsToHumanDuration(durationTripToNextPlanningEvent) : "Inconnu" }}</p>
            <p>Heure conseillée de fin d'intervention : {{ slotProp.next_planning_event.start_time }} - {{ durationTripToNextPlanningEvent != null ? $filters.secondsToHumanDuration(durationTripToNextPlanningEvent) : "Inconnu" }} = {{ advisedEndTime }}</p>
            <p>Durée estimée de l'intervention : {{ interventionDuration }}</p>
            <p>Heure conseillée de début d'intervention : {{ advisedEndTime }} - {{ interventionDuration }} = {{ advisedStartTime }}</p>
          </div>
        </Modal>
      </div>

      <div
        v-if="extendable"
        style="display: flex; flex-grow: 1; justify-content: flex-end; align-items: center; font-size: 2rem; cursor: pointer; min-width: 100px;"
        class="text-muted"
        @click="toggle">
        <i class="extend-icon bi bi-chevron-compact-down" :class="{ 'upside-down': extended }" />
      </div>
    </div>

    <div v-if="slotProp.next_planning_event" class="slot-next-event" :class="{ 'visible': extended }">
      <div style="margin: 10px;">
        <p>
          <strong>Rendez-vous suivant</strong>
        </p>

        <p v-if="slotProp.next_planning_event.intervention">
          <button
            class="btn-link"
            @click="openInterventionInNewTab(slotProp.next_planning_event.intervention.id)">
            Intervention pour {{ $filters.fullname(slotProp.next_planning_event.intervention.contact) }} <i class="bi bi-box-arrow-up-right" />
          </button>
        </p>

        <p v-else-if="slotProp.next_planning_event.event_type == 'personnal_event'">
          Evènement perso
        </p>

        <p v-else-if="slotProp.next_planning_event.event_type == 'leave'">
          Congé
        </p>

        <p>{{ $filters.capitalize(nextPlanningEventStartAndEndDate) }}</p>

        <p style="margin-bottom: 0;">
          Lieu:
          <span
            v-if="slotProp.next_planning_event.location"
            style="margin-left: 5px;">
            {{ slotProp.next_planning_event.location }}
          </span>

          <i
            v-else>Inconnu</i>

          <span
            v-if="slotProp.next_planning_event.latitude && slotProp.next_planning_event.longitude"
            style="margin-left: 5px;">
            ({{ slotProp.next_planning_event.latitude }}, {{ slotProp.next_planning_event.longitude }})
          </span>

          <a
            v-if="slotProp.next_planning_event.latitude && slotProp.next_planning_event.longitude"
            style="margin-left: 5px;"
            :href="`https://www.google.com/maps/search/?api=1&query=${ slotProp.next_planning_event.latitude },${ slotProp.next_planning_event.longitude }`"
            target="_blank"
            class="btn-link">
            <i class="bi bi-geo-alt" />
          </a>
        </p>
      </div>
    </div>

    <SelectSlotModal ref="selectSlotModal" />
  </div>
</template>

<script>


import Modal from "@/components/modals/Modal.vue";
import SelectSlotModal from "@/components/modals/SelectSlotModal.vue";

export default {
  name: "SlotCard",
  components: {
    Modal,
    SelectSlotModal,
  },
  props: {
    slotProp: {
      type: Object,
      required: true,
    },
    extendable: {
      type: Boolean,
      required: false,
      default: false,
    },
    extended: {
      type: Boolean,
      required: false,
      default: false,
    },
    intervention: {
      type: Object,
      required: false,
      default: null,
    },
  },
  emits: ["extend", "collapse"],
  data() {
    return {
      durationTripFromPreviousPlanningEvent: null,
      durationTripToNextPlanningEvent: null,
    };
  },
  computed: {
    previousPlanningEventStartAndEndDate() {
      if (this.slotProp.previous_planning_event == null) {
        return null;
      }

      const previousPlanningEventStartDate = this.$filters.dateStringToHumanizedDate(this.slotProp.previous_planning_event.start_date);
      const previousPlanningEventStartTime = this.slotProp.previous_planning_event.start_time;
      const previousPlanningEventEndDate = this.$filters.dateStringToHumanizedDate(this.slotProp.previous_planning_event.end_date);
      const previousPlanningEventEndTime = this.slotProp.previous_planning_event.end_time;

      if (previousPlanningEventStartDate == previousPlanningEventEndDate) {
        return `${previousPlanningEventStartDate} de ${previousPlanningEventStartTime.substring(0, 5)} à ${previousPlanningEventEndTime.substring(0, 5)}`;
      } else {
        return `Du ${previousPlanningEventStartDate} à ${previousPlanningEventStartTime.substring(0, 5)} au ${previousPlanningEventEndDate} à ${previousPlanningEventEndTime.substring(0, 5)}`;
      }
    },
    nextPlanningEventStartAndEndDate() {
      if (this.slotProp.next_planning_event == null) {
        return null;
      }

      const nextPlanningEventStartDate = this.$filters.dateStringToHumanizedDate(this.slotProp.next_planning_event.start_date);
      const nextPlanningEventStartTime = this.slotProp.next_planning_event.start_time;
      const nextPlanningEventEndDate = this.$filters.dateStringToHumanizedDate(this.slotProp.next_planning_event.end_date);
      const nextPlanningEventEndTime = this.slotProp.next_planning_event.end_time;

      if (nextPlanningEventStartDate == nextPlanningEventEndDate) {
        return `${nextPlanningEventStartDate} de ${nextPlanningEventStartTime.substring(0, 5)} à ${nextPlanningEventEndTime.substring(0, 5)}`;
      } else {
        return `Du ${nextPlanningEventStartDate} à ${nextPlanningEventStartTime.substring(0, 5)} au ${nextPlanningEventEndDate} à ${nextPlanningEventEndTime.substring(0, 5)}`;
      }
    },
    interventionDuration() {
      if (this.intervention == null) {
        return "Inconnu";
      } else {
        return `${this.intervention.duration} minutes`;
      }
    },
    interventionAddress() {
      const location = this.intervention.location;

      return `${location.street}, ${location.zipcode} ${location.city} ${location.country_code}`;
    },
  },
  methods: {
    collapse() {
      this.$emit("collapse");
    },
    extend() {
      this.$emit("extend");
    },
    toggle() {
      if (this.extended) {
        this.collapse();
      } else if (this.extendable) {
        this.extend();
      }
    },
    
    openInterventionInNewTab(interventionId) {
      const routeData = this.$router.resolve({name: "intervention", params: {id: interventionId}});
      window.open(routeData.href, "_blank");
    },
  },
};
</script>

<style lang="scss" scoped>

  .slot {

    .slot-previous-event {
      background-color: #f5f5f5;
      border-top-left-radius: 15px;
      border-top-right-radius: 15px;
      border: 1px solid #ccc;
      border-bottom: none;

      overflow: hidden;
      transition: height 0.3s ease-in-out;
      height: 0px;

      &.visible {
        height: 90px;
      }
    }

    .slot-body {
      padding: 10px;
      border: 1px solid #ccc;
      background-color: white;
      display: flex;
    }

    .slot-next-event {
      background-color: #f5f5f5;
      border-bottom-left-radius: 15px;
      border-bottom-right-radius: 15px;
      border: 1px solid #ccc;
      border-top: none;

      overflow: hidden;
      transition: height 0.3s ease-in-out;
      height: 0px;

      &.visible {
        height: 90px;
      }
    }

  }

  .extend-icon {
    transition: transform 0.3s ease-in-out;

    &.upside-down {
      transform: rotate(180deg);
    }
  }

</style>
